export default "/images/8120b44ca58adec4f7bb8d2fffb7c79e.avif";